import React from "react";

import GetStartedV2 from "./indexInvest";

export default function GetStarted() {
  return <GetStartedV2 />;
}
